<!-- prettier-ignore -->   
 <!-- [disabled]="chatIsTyping() || isStreaming()" -->

<button 
  #dynamicContainer 
  type="button" 
  class="chat__button" 
  [ngClass]="{'is-recording': showRecordIcon() && isRecording()}" 
  (click)="click()"
>
  @if(showRecordIcon() && isRecording()){
    <icon-pulse />
  }@else {
    <icon-voice />
  }
</button>
